import { createUseData } from "../../../../common/hooks/create-use-data/create-use-data";
import { service } from "./admin-assessments.service";

export const useAdminAssessments = createUseData(
    service.getAssessments,
)